import template from './subject.html'

export let subject = {
  bindings: {
    details: '<',
    activity: '<',
    planning: '<',
    teaching: '<',
    label: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['$stateParams', 'Validations', 'CssClasses', 'Ramda', '$state',
  function subjectCtrl ($stateParams, Validations, CssClasses, Ramda, $state) {
    const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
    const icons = CssClasses.icons
    const vm = this
    let inExecution = Validations.inExecution(currentStage)
    let inReviewExecution = Validations.inReviewExecution(currentStage)
    let inEvaluation = Validations.inEvaluation(currentStage)
    const currentModule = $state.current.module

    angular.extend(this, {
      advancedView: inExecution || inEvaluation || inReviewExecution,
      standardView: !inExecution && !inEvaluation && !inReviewExecution,
      children: [],
      chevron: icons.arrowDown,
      showData: false,
      checkChildren: checkChildren,
      toggleChevron: toggleChevron,
      module: currentModule
    })

    this.$onInit = () => {
      this.planning.isPlanning = true
      this.teaching.isPlanning = false
      this.children = [this.planning, this.teaching]
    }

    function checkChildren (children) {
      return children.filter(Boolean).length > 0
    }

    function toggleChevron () {
      if (vm.showData) {
        vm.chevron = icons.arrowDown
        vm.showData = false
      } else {
        vm.chevron = icons.arrowUp
        vm.showData = true
      }
    }
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/subject.js